import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getContactForm (callback) {
    HTTP.get('/form/contact').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  addContactForm (callback, param) {
    if (param !== undefined) {
      HTTP.post('/form/contact', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setContactForm (callback, param) {
    if (param !== undefined) {
      HTTP.put('/form/contact', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        if (e.response.status === 400) {
          callback(e.response)
        }
        console.log(e)
      })
    }
  },
  deleteContactFormById (callback, param) {
    if (param !== undefined) {
      HTTP.delete('/form/contact', {data: {'contact_form_detail_id': param}}).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setContactFormSort (callback, param) {
    if (param !== undefined) {
      HTTP.put('/form/contact/sort_field', param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  importCsvContactFormOption (callback, param) {
    if (param !== undefined) {
      HTTP.post('/form/contact/import_dropdown', param, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setContactFormButton (callback, param) {
    if (param !== undefined) {
      HTTP.put('/form/contact/button', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setSelectContactFormButton (callback, param) {
    if (param !== undefined) {
      HTTP.put('/form/contact/button', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/contact_forms/index.js